import React, { useState } from 'react';
import './Services.css';

interface ServiceItem {
  title: string;
  description: string;
}

interface ServiceColumn {
  category: string;
  services: ServiceItem[];
}

const Services: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<ServiceColumn | null>(null);

  const serviceColumns: ServiceColumn[] = [
    {
      category: "HIGH SCHOOL & COLLEGE SERVICES",
      services: [
        {
          title: "High School & College Writing Support",
          description: "Advanced analytical writing, critical thinking, and essay composition for high school and college students. Includes college application essays, analytical papers, research papers, thesis development, argumentative writing, and academic reading comprehension. Contact for pricing."
        },
        {
          title: "Humanities Tutoring (Grades 9 - College)",
          description: "One-on-one instruction in English, literature, history, social studies, psychology, and political science. Focus on analytical reading, critical thinking, essay writing, and comprehension skills for upper-level students. Afternoon, evening, and weekend sessions available. Customized to student needs. Contact for pricing."
        }
      ]
    },
    {
      category: "READING, WRITING & CRITICAL THINKING",
      services: [
        {
          title: "Reading Comprehension & Critical Thinking (Grades K-College)",
          description: "Develop close reading skills, critical thinking, and analytical reasoning across all grade levels. Strategies for understanding complex texts, making inferences, analyzing content, and building higher-order thinking skills. Contact for pricing."
        },
        {
          title: "Elementary & Middle School Writing (Grades 3-8)",
          description: "Foundational writing instruction including paragraph development, sentence structure, grammar, basic essay composition, and persuasive writing skills. Contact for pricing."
        },
        {
          title: "Executive Function & Study Skills",
          description: "Organization skills, time management, study strategies, and academic coaching for middle school, high school, and college students. Homework support, test preparation, note-taking strategies, and self-regulation skills. Contact for pricing."
        }
      ]
    },
    {
      category: "LITERACY FOUNDATIONS & INTERVENTION",
      services: [
        {
          title: "Intensive Reading Support (Grades 1-8)",
          description: "Intensive, focused science-of-reading instruction for struggling readers. Targeted support for decoding difficulties, fluency building, reading comprehension gaps, and literacy intervention. Evidence-based strategies for students who need extra help. Contact for pricing."
        },
        {
          title: "Early Literacy & Phonics (PK-Grade 3)",
          description: "Foundational reading instruction using science-of-reading principles. Phonics, phonemic awareness, decoding skills, and early literacy development for Pre-K through 3rd grade. Patient, personalized approach for beginning readers. Contact for pricing."
        }
      ]
    }
  ];

  const openModal = (category: ServiceColumn) => {
    setSelectedCategory(category);
  };

  const closeModal = () => {
    setSelectedCategory(null);
  };

  return (
    <section id="services" className="services">
      <div className="services-container">
        <h2>Services</h2>
        <div className="services-grid">
          {serviceColumns.map((column, index) => (
            <div
              key={index}
              className="service-card"
              onClick={() => openModal(column)}
            >
              <h3 className="service-category">{column.category}</h3>
            </div>
          ))}
        </div>
      </div>

      {selectedCategory && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <h3 className="modal-title">{selectedCategory.category}</h3>
            <div className="modal-services">
              {selectedCategory.services.map((service, index) => (
                <div key={index} className="modal-service-item">
                  <h4>{service.title}</h4>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
